// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取小程序模板消息列表 GET /wx-ma/template/list */
export async function wxMaTemplateListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListMaWxTemplateResp>('/wx-ma/template/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 订阅小程序模板消息 GET /wx-ma/template/subscribe */
export async function wxMaTemplateSubscribeUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.wxMaTemplateSubscribeUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/wx-ma/template/subscribe', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
